<div class="preset-delete-modal">
  <mat-toolbar>
    <span>Delete preset</span>
    <span class="spacer"></span>
    <button mat-icon-button (click)="close()" aria-label="Close delete preset dialog">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <div class="content">
    <p>Delete the preset "{{data.name}}"?</p>
    <p class="warning">This action cannot be undone.</p>
  </div>

  <div class="actions">
    <button mat-stroked-button (click)="close()">Cancel</button>
    <button mat-flat-button color="warn" (click)="confirm()">Delete</button>
  </div>
</div>
